import { useRef } from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any

export const useControlledPromise = () => {
  const newResolve = useRef(() => {});
  const newReject = useRef(() => {});

  // https://stackoverflow.com/questions/41078809/typescript-promise-generic-type
  // https://beta.reactjs.org/reference/react/useRef#avoiding-recreating-the-ref-contents
  const promise = useRef(null);
  if (!promise.current) {
    promise.current = new Promise((resolve, reject) => {
      newResolve.current = resolve;
      newReject.current = reject;
    });
  }
  return {
    promise,
    reject: newReject,
    resolve: newResolve
  };
};